import React, { useMemo } from 'react';
import './fan.css';

import chevr from "../assets/image/chevr.png" 
import Group from "../assets/image/Group 13 (2).png" 


const Fan = ({
    title,
    transparentBackground,
    draggable,
    did,
    tid,
    dims,
    value, 
    ...extraProps
}) => {
    const { datastreams = [], alignment, showLabel, maxSpeed = 10 } = extraProps;
    
    const activeDatastream = useMemo(() =>
        (datastreams || []).find(ds => ds.isActive),
        [datastreams]
    );

    const fanValue = value !== undefined ? value : 0; 

    const mouseEvent = (e, cursor) => {
        if (draggable) e.target.closest('.widget-container').style.cursor = cursor;
    };

    const fanSize = useMemo(() => {
        if (!dims) return '80px';
        const { width, height } = dims;
        return `${Math.min(width, height) * 0.6}px`;
    }, [dims]);

    const isOn = useMemo(() => parseFloat(fanValue) !== 0, [fanValue]);
    const activeSpeed = activeDatastream?.speed || 0;

    const animationDuration = isOn && activeSpeed > 0
        ? `${(1.1 - (activeSpeed / maxSpeed)).toFixed(2)}s`
        : '0s';

    return (
        <div
            className="widget-container fan-widget-container"
            onMouseDown={(e) => mouseEvent(e, 'grabbing')}
            onMouseUp={(e) => mouseEvent(e, 'grab')}
            onMouseLeave={(e) => mouseEvent(e, 'grab')}
            draggable={draggable}
            onDragStart={(e) => {
                const id = e.target.closest('.widget').id;
                const rect = e.target.getBoundingClientRect();
                const offsetX = e.clientX - rect.x;
                const offsetY = e.clientY - rect.y;
                let dragData = `fan;${id};${offsetX};${offsetY};`;
                dragData += id.startsWith('base') ? 'add' : 'move';
                e.dataTransfer.setData('text/plain', dragData);
            }}
            style={{
                cursor: draggable ? 'grab' : 'default',
                ...(transparentBackground && {
                    backgroundColor: 'transparent',
                    boxShadow: 'none',
                }),
            }}
        >
            <h3 className="widget-title">{title}</h3>
            <div
                className="fan-content-wrapper"
                style={{ alignSelf: alignment }}
            >
                <div
                    className={`real-fan ${isOn ? 'spin' : ''}`}
                    style={{
                        width: fanSize,
                        height: fanSize,
                        animationDuration: animationDuration,
                    }}
                >
                    <svg viewBox="0 0 100 100" className="fan-svg-background">
                        <defs>
                            <linearGradient id="fan-metal" x1="0%" y1="0%" x2="100%" y2="100%">
                                <stop offset="0%" stopColor="#ccc" />
                                <stop offset="50%" stopColor="#888" />
                                <stop offset="100%" stopColor="#ccc" />
                            </linearGradient>
                        </defs>
                        
                        <circle cx="50" cy="50" r="45" fill="url(#fan-metal)" stroke="#333" strokeWidth="1" />
                        <circle cx="50" cy="50" r="8" fill="#666" stroke="#333" strokeWidth="1" />
                        
                        {[...Array(5)].map((_, i) => (
                            <circle
                                key={`bolt-${i}`}
                                cx={50 + 6 * Math.cos((i * 2 * Math.PI) / 5)}
                                cy={50 + 6 * Math.sin((i * 2 * Math.PI) / 5)}
                                r="1"
                                fill="#222"
                            />
                        ))}
                    </svg>
                    
                    <img 
                        src={Group} 
                        alt="Fan Blades"
                        className="fan-image" 
                        style={{
                            position: 'absolute',
                            width: '85%',
                            height: '85%',
                            top: '7.5%',
                            left: '7.5%',
                            objectFit: 'contain',
                        }}
                    />
                    
                    <img 
                        src={chevr} 
                        alt="Fan Cover/Center"
                        className="fan-overlay" 
                        style={{
                            position: 'absolute',
                            width: '100%',
                            height: '100%',
                            objectFit: 'contain',
                        }}
                    />
                </div>
                {showLabel && (
                    <span className="fan-label">
                        {isOn ? `Running (Speed ${activeSpeed})` : 'Stopped'}
                    </span>
                )}
            </div>
        </div>
    );
};

export default Fan;